var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.785645 30.47C0.785645 13.9016 14.0891 0.469971 30.4999 0.469971C46.9107 0.469971 60.2142 13.9016 60.2142 30.47C60.2142 47.0385 46.9107 60.47 30.4999 60.47C14.0891 60.47 0.785645 47.0385 0.785645 30.47ZM36.3164 29.3653C34.482 29.4685 32.9898 29.3117 31.4978 29.1549C30.0058 28.9981 28.5137 28.8414 26.6791 28.9445C25.7988 28.9941 24.8652 29.1193 23.9782 29.329C24.519 22.7123 29.3217 16.9231 35.8528 16.5558C39.8605 16.3302 43.8658 18.7434 44.0836 22.6602C44.2972 26.5101 41.2865 29.0855 36.3164 29.3653ZM26.4922 43.3135C22.6954 43.5205 18.9008 41.3083 18.6947 37.7178C18.492 34.1889 21.3444 31.8281 26.0527 31.5717C27.7907 31.477 29.2043 31.6207 30.6179 31.7645C32.0315 31.9082 33.4452 32.0519 35.1831 31.9573C36.0173 31.9119 36.9016 31.797 37.7419 31.6046C37.2296 37.6701 32.6794 42.9767 26.4922 43.3135Z",
    fill: "#313131"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus);
export default __webpack_public_path__ + "static/media/status.0ff3772f.svg";
export { ForwardRef as ReactComponent };